<span class="" *ngIf="date_range_filter_key">
<form [formGroup]="form"  class="align-items-center d-flex  ms-2">
    <kendo-datepicker class="form-control" placeholder="{{start_date_place_holder_text}}"  [format]="'MM/dd/yyyy'" formControlName="from_date" style="max-width: 35%;" class="me-2" (click)="$event.stopPropagation()"></kendo-datepicker>
    <kendo-datepicker class="form-control" placeholder="{{end_date_place_holder_text}}"  [format]="'MM/dd/yyyy'" formControlName="to_date" style="max-width: 35%;" class="me-2" (click)="$event.stopPropagation()"></kendo-datepicker>
    <button kendoButton  (click)="search()">Filter</button>
</form>
</span>
